import custom from './custom'
import m from './m'
import reminder from './reminder'

const pageRouters = [
  custom,
  m,
  reminder
]

export default pageRouters
